<template>
    <div v-if="isDisplay"
        :class="['preview-progress-bar', formProgressBar.positionIndex != maxComponent - 1 ? 'm-b-16' : '']">
        <div :class="['swift-progress-bar in-app', formProgressBar.position]">
            <div :class="['progress-bar', formProgressBar.size]" :style="'background-color:' + this.formProgressBar.barColor">
                <div :class="['progress-bar-percent']" :style="styleProgressBar+';width:'+percent+'%'"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { listComponentDefault } from './../../constant'
export default {
    name: "PreviewProgressBar",
    props: {
        value: {
            type: Object,
            required: true,
        },
        isDisplay: {
            type: Boolean,
            required: true
        },
        percent: {
            type: Number,
            default: 0
        }
    },
    computed: {
        formProgressBar: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", this.value);
            },
        },
        styleProgressBar() {
            let style = ''
            if (this.formProgressBar.isUseStripeColor && this.formProgressBar.position === 'middle') {
                style = 'background: repeating-linear-gradient(45deg, '+ this.formProgressBar.loadingColor +', '+ this.formProgressBar.loadingColor +' 10px, ' + this.formProgressBar.stripeColor + ' 10px, ' + this.formProgressBar.stripeColor +' 20px);'
            } else {
                style = 'background-color: ' + this.formProgressBar.loadingColor
            }
            return style
        },
        maxComponent() {
            return listComponentDefault.length
        }
    },
    watch: {

    },
    data() {
        return {
           
        };
    },

    created() {

    },
};
</script>

<style lang="scss">
    .swift-custom-img {
        width: fit-content;
        height: fit-content;
        margin: auto;
    }
</style>
